import React, { useState, useEffect } from 'react'
import qs from 'query-string'
import * as Papa from 'papaparse'

import Collection from './components/Collection/Collection'

import { slugify } from './helpers/helpers'

import './App.scss'

function getSessionStorageOrDefault(key, defaultValue) {
    const stored = sessionStorage.getItem(key)
    if (!stored) {
        return defaultValue
    }
    return JSON.parse(stored)
}

const parsed = qs.parse(window.location.search)

let qsCollectionId

if (parsed.cid && parsed.cid.length) {
    qsCollectionId = parsed.cid
}

const App = React.memo(({ collectionHandle, collectionId, collectionPage, collectionTitle }) => {
    // console.log('collectionId in Appjs', collectionId)
    // console.log('collectionHandle in App', collectionHandle)
    const [collectionData, setCollectionData] = useState()
    // getSessionStorageOrDefault('ma_all_collections', null)

    useEffect(() => {
        if (collectionId) {
            return
        }
        // console.time('fetching collection data')
        // if we don't have cached data, get the data
        if (!collectionData && !collectionId) {
            console.log('grabbing csv data')
            let sc_url =
                'https://data.monicaandandy.com/cc/smart-collections.csv'
            let cc_url =
                'https://data.monicaandandy.com/cc/custom-collections.csv'

            let customCollections
            let smartCollections
            ;(async () => {
                await Papa.parse(sc_url, {
                    download: true,
                    header: true,
                    transformHeader: function (h) {
                        return slugify(h)
                    },
                    complete: function (data) {
                        smartCollections = data.data
                    },
                })
            })()
            ;(async () => {
                await Papa.parse(cc_url, {
                    download: true,
                    header: true,
                    transformHeader: function (h) {
                        return slugify(h)
                    },
                    complete: function (data) {
                        customCollections = data.data
                        // console.log('customCollections', customCollections)
                        buildAllCollections(smartCollections, customCollections)
                    },
                })
            })()
        }

        let allCollections

        // concat the two collection arrays
        function buildAllCollections(col1, col2) {
            if (col1 && col2) {
                allCollections = col1.concat(col2)
            } else if (!col2) {
                allCollections = col1
            } else if (!col1) {
                allCollections = col2
            }

            setCollectionData(allCollections)

            // set collection data to session storage
            sessionStorage.setItem(
                'ma_all_collections',
                JSON.stringify(allCollections)
            )
        }
    }, [collectionData, collectionId])

    return (
        <div className="App PLP-page collection-page mini-plp">
            {(collectionData && collectionData.length) || collectionId ? (
                <Collection
                    collectionData={collectionData}
                    collectionId={collectionId}
                    collectionHandle={collectionHandle}
                    cid={qsCollectionId}
                    collectionPage={collectionPage}
                    collectionTitle={collectionTitle}
                />
            ) : null}
        </div>
    )
})

export default App

/**

How this app works:

We use the Matrixify (Excelify) app in Shopify to export .csv files of all of our collections to our data server twice per day. This gives us up-to-date basic collection data with collection IDs.

On load, we check to see if the user has cached collection data in sessionStorage. If we do have collection data, we grab it from sessionStorage. If not, we fetch the .csv files from our data server and convert to JSON with Papa Parse.

Note: once this app is mounted to the Shopify theme, we should be able to get the collection ID via Liquid and use that, bypassing the .csv steps. *** Update: this does not work; using csv ***

Once we have the collection data, we get the collection slug from the current url and match that to a collection handle from the data. If we have a match, we get the collection ID and with that ID query the Boost API to get the full collection payload with products + variants.

With the payload, we split out all of the variants from products to create a flat variants array which we can then sort. We further split the list of variants into two arrays: one array for variants with rankings and another for variants without rankings.

We sort the array of variants with rankings by "featured" metafield and then randomly shuffle the array of variants without rankings. Then, we concatenate the two arrays to have a sorted list of all variants.

From there, we filter out variants without inventory and then dedupe the list by product ID, leaving a list of unique products that is ranked + sorted. We map over that list, sending the variant + product data to our 'Variant' component so we can populate the swatches + sizes and display the product cards.

The filter logic is also included so we can update the requisite state: variant list and filters.

*/
